<template>
  <div class="google-signin">
    <div ref="btn" class="google-signin-btn"></div>
    <p v-if="statusMessage" class="google-signin-warn">
      {{ statusMessage }}
    </p>
  </div>
</template>

<script>
import { GOOGLE_CLIENT_ID } from '../../config'

const GSI_SRC = 'https://accounts.google.com/gsi/client'

// Load Google Identity Services once, shared across button instances.
function loadGsi () {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.accounts && window.google.accounts.id) {
      return resolve()
    }
    const existing = document.getElementById('google-gsi')
    if (existing) {
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject(new Error('GSI failed to load')))
      return
    }
    const s = document.createElement('script')
    s.src = GSI_SRC
    s.async = true
    s.defer = true
    s.id = 'google-gsi'
    s.onload = () => resolve()
    s.onerror = () => reject(new Error('GSI failed to load'))
    document.head.appendChild(s)
  })
}

export default {
  name: 'GoogleSignInButton',
  data () {
    return {
      clientId: GOOGLE_CLIENT_ID,
      statusMessage: ''
    }
  },
  async mounted () {
    if (!this.clientId) {
      this.statusMessage = 'Google sign-in is not configured.'
      return
    }

    try {
      await loadGsi()
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: (resp) => {
          if (resp && resp.credential) {
            this.$emit('credential', resp.credential)
            return
          }

          this.$emit('error', new Error('Google did not return a sign-in credential.'))
        }
      })
      window.google.accounts.id.renderButton(this.$refs.btn, {
        theme: 'outline',
        size: 'large',
        shape: 'rectangular',
        text: 'continue_with',
        logo_alignment: 'center',
        width: this.buttonWidth()
      })
    } catch (e) {
      // Non-fatal: the email/password form still works.
      this.statusMessage = 'Google sign-in is temporarily unavailable.'
      console.error('[GoogleSignInButton]', e.message)
      this.$emit('error', e)
    }
  },
  methods: {
    buttonWidth () {
      const measured = this.$el ? Math.floor(this.$el.getBoundingClientRect().width) : 360
      return Math.min(400, Math.max(240, measured || 360))
    }
  }
}
</script>

<style scoped>
.google-signin {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 0.4rem;
}
.google-signin-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 38px;
}
.google-signin-warn {
  margin: 0.1rem 0 0;
  color: #9198aa;
  font-size: 11.5px;
}
</style>
